<div [caLocalizationScope]="localizationScope" class="mb-6">
  <span class="heading-20 d-block mb-2" data-automation-id="saved-filters-title">
    {{ 'savedFiltersTitle' | caLocalize | uppercase }}
  </span>
  <f-single-suggester-with-icon
    [items]="suggesterStore.savedFiltersSuggestions()"
    [valuePath]="valuePath"
    [idPath]="idPath"
    [placeholder]="'searchSavedFilter' | caLocalize"
    [iconClass]="'f-i-trash-bin'"
    [isOutlineInput]="false"
    [iconTooltip]="'deleteSavedFilterTooltip' | caLocalize"
    [selectedValue]="suggesterStore.selectedFilter()?.['name']?.toString() ?? ''"
    [showPredefinedSet]="true"
    [lazyLoadPredefinedSet]="false"
    [maxResultsCount]="5"
    (select)="onSelect($event)"
    (reset)="onReset()"
    (iconClick)="onDeleteFilter($event)"
    data-automation-id="saved-filters-suggester"
  >
    <ng-template #fNoDataTemplate
      ><span class="text-muted">{{ 'noSavedFiltersMessage' | caLocalize }}</span></ng-template
    >
  </f-single-suggester-with-icon>
</div>
